import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AddResourceInstanceComposer } from "@/forms/rema/addResourceInstance/composer"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Database } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

function AddResourceInstancePage() {
  const navigate = useNavigate()
  const { toast } = useToast()

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0">
        <CardHeader className="border-b bg-slate-700 text-white [&_p]:text-slate-300">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Database className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Add Resource Instance</CardTitle>
              <CardDescription className="text-base">Create a new resource instance</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="p-6">
          <AddResourceInstanceComposer
            showHeader={false}
            onSuccess={() => navigate({ to: '/rema/resource-instances' })}
            onError={(error) => toast({ title: 'Error', description: `Failed to create instance: ${error.message}`, type: 'error' })}
            onCancel={() => navigate({ to: '/rema/resource-instances' })}
          />
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/rema/resource-instances/add")({
  staticData: {
    title: 'Add Resource Instance',
    isSecured: true,
  },
  component: AddResourceInstancePage,
})
